import { APIConnect } from "./APIConnect"
import { Common } from "./common"
import { SaleProductData } from "./SaleProductData"
import config from 'config'

export default class SaleProductManager {
    constructor() {
        if (config.isDebug) {
            console.log("debug")
            this.productIds = [
            {
                productId: "9",
                productName: "Acrylic S size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "10",
                productName: "Acrylic M size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "11",
                productName: "Acrylic L size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "862",
                productName: "Acrylic S size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "864",
                productName: "Acrylic M size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "866",
                productName: "Acrylic L size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "863",
                productName: "Acrylic S size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "865",
                productName: "Acrylic M size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "867",
                productName: "Acrylic L size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "873",
                productName: "Acrylic S size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "875",
                productName: "Acrylic M size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "877",
                productName: "Acrylic L size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "874",
                productName: "Acrylic S size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "876",
                productName: "Acrylic M size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "878",
                productName: "Acrylic L size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "890",
                productName: "ACRY TICKET S",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "891",
                productName: "ACRY TICKET M",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "892",
                productName: "ACRY TICKET L",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "893",
                productName: "ACRY TICKET S 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "894",
                productName: "ACRY TICKET M 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "895",
                productName: "ACRY TICKET L 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "902",
                productName: "ACRY TICKET 送料負担分",
                delivWeight: 1,  // 送料計算に使用する重み
            },
        ]
        } else {
            console.log("product")
            this.productIds = [
            {
                productId: "8",
                productName: "Acrylic S size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "7",
                productName: "Acrylic M size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "6",
                productName: "Acrylic L size",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2749",
                productName: "Acrylic S size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2751",
                productName: "Acrylic M size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2754",
                productName: "Acrylic L size svg",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2750",
                productName: "Acrylic S size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2752",
                productName: "Acrylic M size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "2755",
                productName: "Acrylic L size sharecode",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3773",
                productName: "Acrylic S size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3775",
                productName: "Acrylic M size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3777",
                productName: "Acrylic L size svg sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3774",
                productName: "Acrylic S size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3776",
                productName: "Acrylic M size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3778",
                productName: "Acrylic L size sharecode sample",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3842",
                productName: "ACRY TICKET S",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3843",
                productName: "ACRY TICKET M",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3844",
                productName: "ACRY TICKET L",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3845",
                productName: "ACRY TICKET S 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3846",
                productName: "ACRY TICKET M 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3847",
                productName: "ACRY TICKET L 送料負担",
                delivWeight: 1,  // 送料計算に使用する重み
            },
            {
                productId: "3854",
                productName: "ACRY TICKET 送料負担分",
                delivWeight: 1,  // 送料計算に使用する重み
            },
        ]
        }
        this.saleProductList = [];
    }
    async update() {
        this.saleProductList = [];
        let ids = [];
        this.productIds.forEach((element) => ids.push(parseInt(element.productId)) );
        await APIConnect.E05(ids).catch((error) => {
            Common.log(error)
            Common.log("E05失敗")
        }).then((result)=>{
            const products = result.products;
            for( let key in products ){
                const product1 = this.productIds.find( (element) => element.productId == key );
                const product2 = products[key];
                this.saleProductList.push(new SaleProductData(product1.productId, product1.productName, product1.delivWeight, product2))
            }
        })
    }
    getProduct(productId) {
        for (let p of this.saleProductList) {
            if (p.productId == productId) {
                return p
            }
        }
        return null
    }
}
export { SaleProductManager }